import React from "react";
import { Sparkles, ShieldCheck, RefreshCw, Headphones, Feather } from "lucide-react";

const ITEMS = [
  { icon: Sparkles, label: "Premium Materials" },
  { icon: ShieldCheck, label: "Secure Payments" },
  { icon: RefreshCw, label: "Easy Returns" },
  { icon: Headphones, label: "Customer Support" },
  { icon: Feather, label: "Quality You Can Feel" },
];

export const TrustStrip = ({ dark = false }) => (
  <section className={`${dark ? "bg-lemce-matte text-lemce-ivory" : "bg-lemce-beige/40 text-lemce-matte"} border-y border-lemce-beige/60`} data-testid="trust-strip">
    <div className="max-w-[1400px] mx-auto px-6 py-8 grid grid-cols-2 md:grid-cols-5 gap-6">
      {ITEMS.map(({ icon: Icon, label }) => (
        <div key={label} className="flex flex-col items-center text-center gap-2">
          <Icon className={`w-5 h-5 ${dark ? "text-lemce-taupe" : "text-lemce-charcoal"}`} strokeWidth={1.5} />
          <span className="text-[11px] tracking-widest uppercase">{label}</span>
        </div>
      ))}
    </div>
  </section>
);

export default TrustStrip;
